import React, { useRef, useEffect, useState } from 'react';
import './Hero.css';
import { scrollToSection } from '../utils/scroll';

const Hero = () => {
  const heroRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const backgroundImageUrl = 'https://res.cloudinary.com/dxenrdunh/image/upload/v1743729238/1715746672947_rka8yc.jpg';
  
  // Safe initialization of state to avoid hydration issues
  useEffect(() => {
    // Only set isMobile after component is mounted to avoid hydration mismatch
    setIsMobile(window.innerWidth <= 768);
    
    // Setup resize handler only after component is mounted
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Add event listener with proper cleanup
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
    }
    
    // Proper cleanup function
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);
  
  // Mobile styles for centering - define outside of render to avoid recreation
  const mobileStyles = {
    container: {
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      padding: '0 15px'
    },
    title: {
      textAlign: 'center',
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    subtitle: {
      textAlign: 'center',
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    button: {
      width: '90%',
      maxWidth: '280px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: '15px'
    }
  };
  
  // Handle scroll to services section
  const handleServicesClick = (e) => {
    e.preventDefault();
    scrollToSection('services');
  };
  
  // Handle opening calendly
  const handleCalendlyClick = (e) => {
    e.preventDefault();
    window.open('https://www.calendly.com/clarityimpactfinance', '_blank');
  };
  
  // Handle scroll to about section
  const handleAboutClick = (e) => {
    e.preventDefault();
    scrollToSection('about');
  };

  return (
    <section id="home" className="hero static-hero dark-background" ref={heroRef} style={{backgroundImage: `url(${backgroundImageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
      {/* Static hero content - no animations */}
      <div 
        className="hero-content centered-content static-content"
        style={isMobile ? mobileStyles.container : {}}
      >
        <h1 
          className="hero-title"
          style={isMobile ? mobileStyles.title : {}}
        >
          Transforming Communities Through Finance
        </h1>
        
        <h2 
          className="hero-subtitle"
          style={isMobile ? mobileStyles.subtitle : {}}
        >
          We Help Mission-Driven Lenders Increase their Community Impact
        </h2>
        
        <div 
          className="hero-buttons"
          style={isMobile ? mobileStyles.buttonContainer : {}}
        >
          <button 
            className="primary-btn"
            onClick={handleServicesClick}
            style={isMobile ? mobileStyles.button : {}}
          >
            Explore Our Services
          </button>
          
          <button 
            className="secondary-btn"
            onClick={handleCalendlyClick}
            style={isMobile ? mobileStyles.button : {}}
          >
            Book a Discovery Call
          </button>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="scroll-indicator">
        <p className="scroll-text">Our Vision</p>
        <span onClick={handleAboutClick}>↓</span>
      </div>
    </section>
  );
};

export default Hero;